__turbopack_context__.v({
  "badge": "ReserveNowBadge-module__uuUVmG__badge",
  "badgeWrapper": "ReserveNowBadge-module__uuUVmG__badgeWrapper",
  "hasMobileString": "ReserveNowBadge-module__uuUVmG__hasMobileString",
});
